export default {
  name: 'flex',
  type: 'layout',
  data: {}
}
